import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['common'] = {
    calls:          'Қоңыраулар',
    comment:        'Пікір',
    dateTimeFull:   'DD.MM.YY ж., HH:mm:ss',
    forms:          'Өтінімдер',
    send:           'Жіберу',
    somethingWrong: 'Бірдеңе дұрыс болмады',
    understood:     'Түсінікті',
};

export default kk;
